// extracted by mini-css-extract-plugin
export var Container = "styles-module--Container--3gTjc";
export var Choices = "styles-module--Choices--my6fe";
export var Choice_Label = "styles-module--Choice_Label--1iHdw";
export var Choice_Label_Checked = "styles-module--Choice_Label_Checked--18DJG";
export var Choice_Input = "styles-module--Choice_Input--1qnHh";